export default __webpack_public_path__ + "bb2a521bdb3bce665b4401ed33eb6c84.png";